import { Tooltip } from "@fluentui/react-components";
import React from "react";

const SIZE = 16;
const STROKE = 2.5;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const TRACK_COLOR = "#E0E0E0";
const NORMAL_COLOR = "#342c82";
const WARNING_COLOR = "#D97706";
const FULL_COLOR = "#C50F1F";
const WARNING_THRESHOLD = 0.8;

const getColor = (ratio) => {
    if (ratio >= 1) return FULL_COLOR;
    if (ratio >= WARNING_THRESHOLD) return WARNING_COLOR;
    return NORMAL_COLOR;
};

// Circular indicator that fills clockwise from the top as `ratio` (0 to 1) grows.
const FillRing = ({ ratio = 0, title }) => {
    const clamped = Math.min(1, Math.max(0, ratio));

    return (
        <Tooltip
            content={title || `${Math.ceil(clamped * 100)}% used`}
            relationship="label"
        >
            <svg
                width={SIZE}
                height={SIZE}
                viewBox={`0 0 ${SIZE} ${SIZE}`}
                role="img"
                aria-label={title || `${Math.ceil(clamped * 100)}% used`}
                style={{ display: "block" }}
            >
                <circle
                    cx={SIZE / 2}
                    cy={SIZE / 2}
                    r={RADIUS}
                    fill="none"
                    stroke={TRACK_COLOR}
                    strokeWidth={STROKE}
                />
                <circle
                    cx={SIZE / 2}
                    cy={SIZE / 2}
                    r={RADIUS}
                    fill="none"
                    stroke={getColor(clamped)}
                    strokeWidth={STROKE}
                    strokeLinecap="round"
                    strokeDasharray={CIRCUMFERENCE}
                    strokeDashoffset={CIRCUMFERENCE * (1 - clamped)}
                    transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
                />
            </svg>
        </Tooltip>

    );
};

export default FillRing;
